import React from 'react'
import styled from 'styled-components'

import BrandLogoUpload from 'components/BrandLogoUpload'
import ColorInput from 'components/ColorInput'
import { Select } from 'semantic-ui-react'
import { SURVEY_FONTS } from 'organisms/BrandSettings'
import { SYSTEM_FONT_CSS_VALUE } from 'organisms/BrandSettings/utils'
import constants from 'config/constants'
import ErrorText from 'shared/components/forms/ErrorText'

const FieldGroup = styled.div`
  .field:not(:last-child) {
    margin-bottom: 16px !important;

    & > label {
      margin-bottom: 10px !important;
    }
  }

  .field:first-child {
    margin-top: 0 !important;
  }
`

/**
 * @typedef Logo
 * @property {string} imagePreview
 * @property {object} file
 *
 * @param {object} props
 * @param {Logo} props.logoObject
 * @param {function} props.setLogoObject
 * @param {string} props.accentColor
 * @param {function} props.setAccentColor
 * @param {string=} props.font
 * @param {function} props.setFont
 * @param {number} props.brandId
 * @param {boolean} props.hasManageBrandsPermission
 * @param {string=} props.name
 * @param {function} props.setName
 * @param {string=} props.nameError
 */
export default function BasicCustomStyle({
  logoObject,
  setLogoObject,
  accentColor,
  setAccentColor,
  font,
  setFont,
  brandId,
  hasManageBrandsPermission,
  name,
  setName,
  nameError,
}) {
  function handleImageUpload(e) {
    const file = e.target.files[0]
    if (file) {
      const reader = new FileReader()
      reader.onload = function () {
        setLogoObject({
          imagePreview: reader.result,
          file,
        })
      }
      reader.readAsDataURL(file)
    }
  }

  function getFontOption() {
    const systemFont = {
      key: 'System Font',
      value: 'System Font',
      text: (
        <span
          style={{
            fontFamily: SYSTEM_FONT_CSS_VALUE,
          }}
        >
          System Font
        </span>
      ),
    }
    const googleFonts = SURVEY_FONTS.map((font) => ({
      key: font,
      value: font,
      text: <span style={{ fontFamily: font }}>{font}</span>,
    }))
    return [systemFont, ...googleFonts]
  }

  return (
    <FieldGroup>
      <div className={`field${nameError ? ' error' : ''}`}>
        <label className="mb2">Name</label>
        <input
          type="text"
          value={name}
          onChange={setName}
          disabled={!hasManageBrandsPermission}
        />
        {nameError && <ErrorText>{nameError}</ErrorText>}
      </div>
      <div className="field">
        <label>Logo</label>
        <BrandLogoUpload
          id={brandId}
          imagePreview={logoObject.imagePreview}
          file={logoObject.file}
          handleImageUpload={handleImageUpload}
          disabled={!hasManageBrandsPermission}
        />
      </div>
      <ColorInput
        fieldName="Accent color"
        colorOptions={constants.ACCENT_COLOR_OPTIONS}
        color={accentColor}
        defaultColor={accentColor}
        onColorChange={setAccentColor}
        disabled={!hasManageBrandsPermission}
      />
      <div className="field">
        <label>Font</label>
        <Select
          disabled={!hasManageBrandsPermission}
          placeholder="Select your font"
          value={font}
          options={getFontOption()}
          onChange={(e, { value }) => setFont(value)}
        />
      </div>
    </FieldGroup>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/BasicCustomStyle/index.js